import { SearchOutput, SearchUseCase } from './search-use-case';
import { GeneralSearchUseCase } from './general-search';

// TODO: DEletar isso aos remover o general-search no PRIME
export class GeneralSearchFundsUseCase implements SearchUseCase {
  async execute(term: string): Promise<SearchOutput> {
    let result = await GeneralSearchUseCase.getAssets(term);

    if (result?.length === 0) {
      return {
        categories: [{ label: 'Tudo', disabled: false, slug: 'all' }],
        groupedAssets: {},
      };
    }

    result = result.filter((asset) =>
      asset.type.includes('Fundos de Investimentos')
    );

    const formattedAssets = GeneralSearchUseCase.assetsFormatter(result);

    const { categories, groupedAssets } =
      GeneralSearchUseCase.groupAssetsByCategory(formattedAssets);

    const formattedAssetsList = Object.entries(groupedAssets).reduce(
      (acc, [category, list]: any) => {
        return {
          ...acc,
          [category]: list.map(
            (asset: any) =>
              ({
                ...asset.toJson(),
                url: asset.canonical_url,
                enable: !asset.isDisabled(true),
              } as any)
          ),
        };
      },
      {}
    );

    return {
      categories: categories,
      groupedAssets: formattedAssetsList,
    } as any;
  }
}
